/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.rotation[_ngcontent-%COMP%]{position:absolute;left:20px;bottom:15px;top:unset;right:unset;z-index:10;width:40px;height:40px;background:#aa5b23;color:#fff;border:none;border-radius:7px}.icon-pause[_ngcontent-%COMP%], .icon-play[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:20px;height:20px;transition:opacity .3s ease;opacity:1}"];
export { styles as styles };
